import { render } from "./DeletedParcels.vue?vue&type=template&id=35228026&scoped=true"
import script from "./DeletedParcels.vue?vue&type=script&lang=js"
export * from "./DeletedParcels.vue?vue&type=script&lang=js"

import "./DeletedParcels.vue?vue&type=style&index=0&id=35228026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35228026"]])

export default __exports__